import React, { useEffect, useState, useRef } from 'react';
import { Button, InputX, Input, Select, LayerBottom, Toast } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'
import { useNavigate } from 'react-router-dom'
import Lib from 'library'
import { useSetRecoilState } from 'recoil'
import { userLogInfoState } from './states'


const Join = () => {

	const App = useApp()
	const navigate = useNavigate()

	const setUserInfo = useSetRecoilState(userLogInfoState)

	const [showLayer, setShowLayer] = useState(false)
	const [showToast, setShowToast] = useState(false)
	const [showRed, setShowRed] = useState(false)

	// 폼벨류
	const [telecom, setTelecom] = useState()
	const [telNum, setTelNum] = useState("")
	const [userName, setUserName] = useState("")
	const [socialNum1, setSocialNum1] = useState("")
	const [socialNum2, setSocialNum2] = useState("")

	const [buttonDisabled, setButtonDisabled] = useState(true)
	const [toastText, setToastText] = useState("")

	const social2 = useRef()

	// step
	const [step, setStep] = useState(0)

	const takeStep = () => {
		if (step < 2) {
			setStep(step => step += 1)
			setButtonDisabled(true)
		} else {
			switch (Lib.isAdult(socialNum1)) {
				case undefined:
					setToastText("잘못된 주민번호입니다.")
					setShowToast(true)
					break
				case false:
					setShowLayer(true)
					break
				case true:
					setUserInfo(info => {
						return {
							...info,
							cphNo: telNum,
							nm: userName,
							rsdtRegNo: `${socialNum1}${socialNum2}`,
							tcomCd: telecom
						}
					})

					Lib.post(`/api/mb/join/auth/req`, {
						cphNo: telNum,
						nm: userName,
						rsdtRegNo: `${socialNum1}${socialNum2}`,
						tcomCd: telecom
					}, data => {
						setShowRed(false)
						navigate("/joinNumber", {
							state: {
								info: {
									cphNo: telNum,
									nm: userName,
									rsdtRegNo: `${socialNum1}${socialNum2}`,
									tcomCd: telecom
								}
							}
						})
					}, error => {
						setShowRed(true)
					})

					/* navigate("/joinNumber", {
						state: {
							info: {
								cphNo: telNum,
								nm: userName,
								rsdtRegNo: `${socialNum1}${socialNum2}`,
								tcomCd: telecom
							}
						}
					}) */
					break
			}
		}
	}

	useEffect(() => {
		let input
		switch (step) {
			case 1:
				input = document.querySelector("[name='socialNum1']")
				break
			case 2:
				input = document.querySelector("[name='telNum']")
				break
		}
		if (input) input.focus()
	}, [step])

	useEffect(() => {
		if (
			step >= 0 && userName.length === 0
			||
			step >= 1 && (socialNum1.length < 6 || socialNum2.length < 1)
			||
			step >= 2 && (typeof telecom === "undefined" || telNum.length < 10)
		) {
			setButtonDisabled(true)
		} else {
			setButtonDisabled(false)
		}
	}, [userName, telecom, telNum, socialNum1, socialNum2])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		document.querySelector("[name='userName']").focus()
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>입력정보 확인</h3>
				{
					showRed &&
					<span className={`${styles.warn} mt_10 text-red`}>입력하신 정보를 다시 확인해주세요.</span>
				}

				{
					step >= 2 &&
					<>
						<p className="guide-title mt_40">휴대폰번호</p>
						<div className="flex-align_center mt_10">
							<Select placeholder="선택" title="통신사" style={{ width: "12rem" }} selected={telecom} data={[
								{ key: "SKT", value: 0 },
								{ key: "KT", value: 1 },
								{ key: "LG U+", value: 2 },
								{ key: "SKT 알뜰폰", value: 3 },
								{ key: "KT 알뜰폰", value: 4 },
								{ key: "LG U+알뜰폰", value: 5 },
							]} onSelect={(key, value) => {
								setTelecom(value)
							}}>
							</Select>
							<InputX name="telNum" tabindex="4" type="tel" placeholder="휴대폰 번호 입력" defaultValue={telNum} setValue={setTelNum} className="flex--item_1 ml_20" maxlength="11" onChange={e => {
								setTelNum(e.target.value)
							}} onKeyPress={e => {
								if (!buttonDisabled && e.which === 13) takeStep()
							}} />
						</div>
					</>
				}

				{
					step >= 1 &&
					<>
						<p className="guide-title mt_40">주민등록번호</p>
						<div className="flex-align_center mt_10" style={{ position: "relative" }}>
							<InputX name="socialNum1" tabindex="2" type="tel" placeholder="주민번호 앞 6자리" defaultValue={socialNum1} setValue={setSocialNum1} className="flex_1" maxlength="6" onChange={e => {
								setSocialNum1(e.target.value)
							}} onKeyPress={e => {
								if (e.which === 13) {
									social2.current.focus()
								}
							}} />
							<span style={{ margin: "0 0.5rem" }}>-</span>
							<div className="flex--item_1">
								<Input ref={social2} tabindex="3" type="tel" style={{ width: "3rem", paddingRight: 0, textAlign: "center" }} maxlength="1" onChange={e => {
									setSocialNum2(e.target.value)
								}} onKeyPress={e => {
									if (!buttonDisabled && e.which === 13) takeStep()
								}} />
								<div className="floating-dots">
									<span />
									<span />
									<span />
									<span />
									<span />
									<span />
								</div>
							</div>
						</div>
					</>
				}


				<p className="guide-title mt_40">이름</p>
				<InputX name="userName" tabindex="1" type="text" placeholder="이름 입력" setValue={setUserName} className="mt_10" onChange={e => {
					const value = e.target.value
					setUserName(value)
				}} onKeyPress={e => {
					if (!buttonDisabled && e.which === 13) takeStep()
				}} />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={takeStep}>다음</Button>
			</div>

			<ConfirmLayer show={showLayer} closeLayer={() => setShowLayer(false)} />

			<Toast show={showToast} setShow={setShowToast} text={toastText} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div>
				<div className="flex-justify_center">
					<i className="icon icon_report_intro" style={{ width: "7rem", height: "6rem" }} />
				</div>
				<div className="layer-text mt_20">
					<p>모니 앱은 만 19세 이상 회원 가입 및 이용이 가능해요.</p>
					<span style={{ color: "#999" }}>정보 확인 후 다시 시도 해주세요.</span>
				</div>
			</div>
		</LayerBottom>
	)
}

export default Join